export default __webpack_public_path__ + "static/woodward_crop_1971x2956-668f827b17168ce6d92ac984423cfa0a.jpg";